import { ValidationMessage } from 'ui';
import { ComplexValue } from 'app/types-shared';
import { ListAction, ListBranchItem,
  ListBranchModel, Visibility } from './types-store';
import { RowSelection } from './types';

export const ACTION = {
  CLEAR_ALL: 'USER_MEMBERS:CLEAR_ALL',
  CLEAR_SUBSCRIBER_GROUP_VALUE: 'USER_MEMBERS:CLEAR_SUBSCRIBER_GROUP_VALUE',

  CLEAR_LIST: 'USER_MEMBERS:CLEAR_LIST',
  REQUEST_LIST_BRANCH: 'USER_MEMBERS:REQUEST_LIST_BRANCH',
  RECEIVE_LIST_BRANCH: 'USER_MEMBERS:RECEIVE_LIST_BRANCH',
  FAIL_LIST_BRANCH: 'USER_MEMBERS:FAIL_LIST_BRANCH',

  ADD_LIST_ACTION: 'USER_MEMBERS:ADD_LIST_ACTION',
  CLEAR_ACTION_ERRORS: 'USER_MEMBERS:CLEAR_ACTION_ERRORS',

  UPDATE_SUBSCRIBER_GROUP: 'USER_MEMBERS:UPDATE_SUBSCRIBER_GROUP',
  UPDATE_ACTIVE_VALUE: 'USER_MEMBERS:UPDATE_ACTIVE_VALUE',

  UPDATE_VISIBILITY: 'USER_MEMBERS:UPDATE_VISIBILITY',
  SELECT_ROW: 'USER_MEMBERS:SELECT_ROW',

  REQUEST_SAVE_CHANGES: 'USER_MEMBERS:REQUEST_SAVE_CHANGES',
  RECEIVE_SAVE_CHANGES: 'USER_MEMBERS:RECEIVE_SAVE_CHANGES',
  FAIL_SAVE_CHANGES: 'USER_MEMBERS:FAIL_SAVE_CHANGES',
  CANCEL_CHANGES: 'USER_MEMBERS:CANCEL_CHANGES'
};

export class ClearAll {
  public type: string = ACTION.CLEAR_ALL;
}

export class ClearSubscriberGroupValue {
  public type: string = ACTION.CLEAR_SUBSCRIBER_GROUP_VALUE;
}

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public model: ListBranchModel) { }
}

export class RequestListBranch {
  public type: string = ACTION.REQUEST_LIST_BRANCH;
  constructor(public model: ListBranchModel, public id: number) { }
}

export class ReceiveListBranch {
  public type: string = ACTION.RECEIVE_LIST_BRANCH;
  constructor(
    public model: ListBranchModel, public id: number,
    public listBranchItems: ListBranchItem[], public numberOfResults: number, public clearList: boolean
  ) { }
}

export class FailListBranch {
  public type: string = ACTION.FAIL_LIST_BRANCH;
  constructor(public model: ListBranchModel, public id: number) { }
}

export class AddListAction {
  public type: string = ACTION.ADD_LIST_ACTION;
  constructor(public actions: ListAction[]) { }
}

export class ClearActionErrors {
  public type: string = ACTION.CLEAR_ACTION_ERRORS;
  constructor(public fixListActions: boolean) { }
}

export class UpdateSubscriberGroup {
  public type: string = ACTION.UPDATE_SUBSCRIBER_GROUP;
  constructor(public value: ComplexValue<number>) { }
}

export class UpdateActiveValue {
  public type: string = ACTION.UPDATE_ACTIVE_VALUE;
  constructor(public value: ComplexValue<number>) { }
}

export class UpdateVisibility {
  public type: string = ACTION.UPDATE_VISIBILITY;
  constructor(public visibility: Visibility) { }
}

export class SelectRow {
  public type: string = ACTION.SELECT_ROW;
  constructor(public selection: RowSelection) { }
}

export class RequestSaveChanges {
  public type: string = ACTION.REQUEST_SAVE_CHANGES;
  constructor(
    public model: ListBranchModel,
    public activeValue: ComplexValue<number>
  ) { }
}

export class ReceiveSaveChanges {
  public type: string = ACTION.RECEIVE_SAVE_CHANGES;
  constructor(
    public model: ListBranchModel,
    public activeValue: ComplexValue<number>
  ) { }
}

export class FailSaveChanges {
  public type: string = ACTION.FAIL_SAVE_CHANGES;
  constructor(
    public model: ListBranchModel,
    public activeValue: ComplexValue<number>,
    public actionErrors: ValidationMessage[],
    public activeValueError: ValidationMessage
  ) { }
}

export class CancelChanges {
  public type: string = ACTION.CANCEL_CHANGES;
}
